/**
 * "On this page" navigation highlighting. For every <nav data-cr-scroll-spy="<active class>">,
 * observes the elements its #anchor links point at and marks the link of the
 * section currently in view with the active class and aria-current="true".
 * Uses IntersectionObserver instead of scroll listeners, so there is no
 * layout work on scroll.
 */
function initScrollSpy(nav) {
  if (nav.dataset.crScrollSpyReady) return;
  nav.dataset.crScrollSpyReady = 'true';

  const activeClass = nav.dataset.crScrollSpy;
  const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
  const targets = new Map();
  for (const link of links) {
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    const target = id && document.getElementById(id);
    if (target) targets.set(target, link);
  }
  if (targets.size === 0) return;

  const visible = new Set();
  const setActive = (activeLink) => {
    for (const link of links) {
      const active = link === activeLink;
      if (activeClass) link.classList.toggle(activeClass, active);
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      }
      // First visible section in document order wins.
      const first = Array.from(targets.keys()).find((target) => visible.has(target));
      if (first) setActive(targets.get(first));
    },
    { rootMargin: '-120px 0px -55% 0px' }
  );
  targets.forEach((_, target) => observer.observe(target));
}

function initAll() {
  document.querySelectorAll('nav[data-cr-scroll-spy]').forEach(initScrollSpy);
}

initAll();
document.addEventListener('shopify:section:load', initAll);
